import { Injectable } from "@angular/core";
import { ReleaseEnvironment } from "../models/release-environment";
import { DeployPhase } from "../models/deploy-phase";
import { HistoryDocument } from "../models/history-document";
import { Variable } from "../models/variable";
import { WorkflowTask } from "../models/workflow-task";
import { KeyValue } from "../models/key-value";

@Injectable({
  providedIn: 'root'
})

export class HistoryService {
  constructor() { }

  getHistory(releaseDefJson: string): HistoryDocument {
    const releaseDefinition = JSON.parse(releaseDefJson);
    const history = new HistoryDocument();

    this.setDocumentDetails(releaseDefinition, history);
    this.mapEnvironments(releaseDefinition, history);
    this.mapVariables(releaseDefinition, history);
    
    return history;
  }

  setDocumentDetails(releaseDefinition: any, history: HistoryDocument) {
    history.name = releaseDefinition.name;
    history.modifiedBy = releaseDefinition.modifiedBy?.displayName;
    history.comment = releaseDefinition.comment;
    history.modifiedDate = releaseDefinition.modifiedOn;
    history.revision = releaseDefinition.revision;
  }

  mapEnvironments(releaseDefinition: any, history: HistoryDocument) {
    const environments = [...(releaseDefinition.environments as Array<ReleaseEnvironment>)].sort((a, b) => a.rank - b.rank);

    environments.forEach((environment: ReleaseEnvironment) => {
      const phases: DeployPhase[] = [];
      const sortedDeployPhases = [...environment.deployPhases].sort((a, b) => a.rank - b.rank);
      sortedDeployPhases.forEach(dp => {
        const wfTasks: WorkflowTask[] = [];
        dp.workflowTasks.forEach(wfTask => {
          const inputs: KeyValue[] = [];
          for (const i in wfTask.inputs) {
            inputs.push({ key: i, value: String(wfTask.inputs[i]), status: 'unchanged' });
          }
          wfTasks.push(new WorkflowTask(wfTask.name, wfTask.id, wfTask.enabled, inputs));
        });
        phases.push(new DeployPhase(dp.name, dp.rank, wfTasks));
      });
      history.environments.push(new ReleaseEnvironment(environment.name, environment.id, environment.rank, phases));
    });
  }

  mapVariables(releaseDefinition: any, history: HistoryDocument) {
    for (const i in releaseDefinition.variables) {
      history.variables.push(new Variable(i, releaseDefinition.variables[i].value, 'Release'));
    }
    releaseDefinition.environments.forEach((env: ReleaseEnvironment) => {
      for (const i in env.variables) {
        history.variables.push(new Variable(i, env.variables[i].value, env.name));
      }
    });
  }
}